<div class="fc-content popover-wrapper" [ngbPopover]="template" container="body" triggers="manual">
  <ng-content></ng-content>
</div>
